import { render, staticRenderFns } from "./CheckoutPaymentMethod.vue?vue&type=template&id=60cca504&scoped=true"
import script from "./CheckoutPaymentMethod.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPaymentMethod.vue?vue&type=style&index=0&id=60cca504&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cca504",
  null
  
)

export default component.exports